import Div from "@jumbo/shared/Div";

export const TabPanel = ({ children, value, index, sx, height = "100%" }) => (
  <div
    style={{
      display: value === index ? "block" : "none",
      height: height,
      overflow: "auto",
    }}
  >
    {value === index && (
      <Div sx={{ height: height, p: 2, ...sx }}>{children}</Div>
    )}
  </div>
);
